import { render } from "./EventList.vue?vue&type=template&id=5408d2bd&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=ts"
export * from "./EventList.vue?vue&type=script&lang=ts"

import "./EventList.vue?vue&type=style&index=0&id=5408d2bd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5408d2bd"

export default script